import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

export const AllergenConfigRowSchema = z.object({
  config_id:     uuidSchema,
  allergen_name: z.string(),
  severity:      z.string().nullable(),
  system_action: z.enum(['NONE', 'SOFT_STOP', 'HARD_STOP']).nullable(),
});

export type AllergenConfigRow = z.infer<typeof AllergenConfigRowSchema>;

